var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.03 18.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22,8.57h-1.41v4.72l-1.93-1.93-.99,.99,3.66,3.57,3.62-3.62-.99-.99-1.97,1.97v-4.72ZM1.41,18.79c-.38,0-.7-.14-.99-.42-.28-.28-.42-.61-.42-.99V1.41c0-.38,.14-.7,.42-.99,.28-.28,.61-.42,.99-.42H9.89l5.14,5.14v12.24c0,.38-.14,.7-.42,.99-.28,.28-.61,.42-.99,.42H1.41ZM9.18,5.78V1.41H1.41v15.97H13.62V5.78h-4.44ZM1.41,1.41v0Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d237988719510fd63656e4711d0b9b98.svg";
export { ForwardRef as ReactComponent };